import React, { Component } from 'react';
import axios from 'axios';
import { withTranslation } from 'react-i18next';

class Question4 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			val: '',
			data: ''
		};

    this.sendFeedback = this.sendFeedback.bind(this);
		this.getReviewLinks = this.getReviewLinks.bind(this);
		this.closeFeedback = this.closeFeedback.bind(this);

	}

	componentDidMount() {
		// scroll back to top page
		window.scrollTo(0, 0);

		this.getReviewLinks();

	}

	render() {
		if(this.state.data) {
			let reviewLinks = this.state.data;

	    return(
	      <div className="feedback-question">
					<h2>{this.props.t('Question4-Wil je ons helpen door ons te beoordelen op')} {reviewLinks['review-link'].key}?</h2>
	        <p>{this.props.t('Question4-Heel erg bedankt dat je de moeite hebt genomen om feedback te geven')}.</p>
	        <p>{this.props.t('Question4-Onze laatste vraag, zou je ons willen helpen door Framefit te beoordelen op')} <a href={reviewLinks['review-link'].value} target="blank">{reviewLinks['review-link'].key}</a></p>
	        <div className="input-container row">

	        </div>
	        <div className="button-container row">
	          <div className="col">
	            <button className="btn btn-default" onClick={() => {this.closeFeedback()}}>{this.props.t('Question4-Nee liever niet')}</button>
	          </div>

	          <div className="col">
	            <button className="btn btn-primary col" onClick={() => {this.sendFeedback()}}>{this.props.t('Question4-Ja graag')}</button>
	          </div>
	        </div>
	      </div>
	    )
		} else {
			return(
				<div className="feedback-question"></div>
			);

		}

	}

	getReviewLinks = function() {
    let url = '/feedback/review-link';
    axios.get(url).then(response => {
		this.setState({data: response.data});
	}).catch(response => {
  		console.log('error');
	})
  }


  sendFeedback = function () {
    let url = this.state.data['review-link'].value;
    var win = window.open(url, '_blank');
    win.focus();
    this.props.nextQuestion(6);

  }

	closeFeedback = function () {
		this.props.nextQuestion(6);
	}


}

export default withTranslation('result')(Question4);
